/**
 * ArtImage: one painted piece, in whichever of its sizes suits the screen.
 * Renders nothing if the piece has not been made yet, so callers can place it
 * unconditionally and fall back however they like.
 */
import React from 'react';
import { getArt } from './artFiles';

const ArtImage = ({ stem, alt, sizes, width, height, eager = false, className }) => {
  const art = getArt(stem);
  if (!art) return null;

  return (
    <img
      src={art.src}
      srcSet={art.srcSet}
      sizes={sizes}
      alt={alt}
      width={width}
      height={height}
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
      className={className}
    />
  );
};

export default ArtImage;
